import { ModuleConfig, ModuleName } from "./types";

export const DEFAULT_MODULES: ModuleConfig[] = [
  {
    name: ModuleName.ProjectPanel,
  },
  {
    name: ModuleName.LayerList,
    options: {
      content: "layers",
      allowDevView: true,
    },
  },
  {
    name: ModuleName.Map,
  },
  {
    name: ModuleName.FeatureCard,
  },
  {
    name: ModuleName.ScaleControl,
  },
  {
    name: ModuleName.DateFilterControl,
  },
  {
    name: ModuleName.DateFilter,
  },
  {
    name: ModuleName.GeoLocation,
  },
  {
    name: ModuleName.BasemapSelect,
    options: {
      items: [
        {
          name: "osm_mono",
          theme: "light",
          title: "OSM",
          preview: "",
        },
      ],
    },
  },
  {
    name: ModuleName.Tools,
    options: {
      items: [
        {
          name: "print",
          route: {
            type: "PRINT",
          },
          imageName: "print",
        },
        {
          name: "buffer",
          imageName: "buffer",
        },
        {
          name: "geometrySelection",
          imageName: "geometrySelection",
        },
        {
          name: "aggregation",
          imageName: "aggregation",
        },
        {
          name: "groundInfo",
          imageName: "groundInfo",
        },
      ],
    },
  },
  {
    name: ModuleName.Notifications,
  },
  {
    name: ModuleName.Print,
  },
  {
    name: ModuleName.BookmarkControl,
  },
  {
    name: ModuleName.Style,
  },
  {
    name: ModuleName.StyleEditor,
  },
  {
    name: ModuleName.Dashboard,
  },
  {
    name: ModuleName.LayerConfiguration,
  },
  {
    name: ModuleName.ProjectConfiguration,
  },
  {
    name: ModuleName.ConfigurationsTable,
  },
  {
    name: ModuleName.SymbolLibrary,
  },
  {
    name: ModuleName.MeasurerControl,
  },
  {
    name: ModuleName.Snapping,
  },
  {
    name: ModuleName.Catalog,
  },
  {
    name: ModuleName.AddressSearch,
    options: {
      provider: "2gis",
    },
  },
  {
    name: ModuleName.Table,
  },
  {
    name: ModuleName.Feedback,
  },
  {
    name: ModuleName.Help,
  },
];
